import { render, staticRenderFns } from "./Keyword.vue?vue&type=template&id=42007eb6&scoped=true"
import script from "./Keyword.vue?vue&type=script&lang=js"
export * from "./Keyword.vue?vue&type=script&lang=js"
import style0 from "./Keyword.vue?vue&type=style&index=0&id=42007eb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42007eb6",
  null
  
)

export default component.exports